// extracted by mini-css-extract-plugin
module.exports = {"preOrderMessage":"PreOrderMessages_preOrderMessage__OuU3p"};